<script setup>
import {defineComponent, onMounted, ref, useTemplateRef} from 'vue'
import {loadPayline} from '@/payline-helper.js'
import {useRoute} from 'vue-router'
import axios from 'axios'

defineComponent({
  name: 'Rechargement'
})

// Commun
const titres = ref([])
const numeroRechargement = ref(null)
const needFacture = ref(false)
const email = ref(null)
const suiteForm = ref(false)
const paymentToken = ref(undefined)
const isAchatCollapsed = ref(false)
const isPaiementCollapsed = ref(true)
const loadingTitre = ref(false)
const loading = ref(false)
const erreurMessage = ref(null)
const now = new Date()
const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
const titreSelectionne = ref("")
let dateDebutTitre = ref('')
const justificatifProduitFile = ref(null);
const justificatifValidationMessage = ref("");

// Achat
const produit = ref(null)
let dateDebutNewTitre = ref(today)
let nouvelleDateFinValiditeeNewTitre = ref(today)
let isNewTitreSelected = ref(false)
const catalogue = ref([])
const carteVide = ref(null)
let numRechargementSelectionne = null;

const rechargementBloque = ref(false)

const titreList = useTemplateRef('titre-list')

const route = useRoute()

function toggleCollapse() {
  isAchatCollapsed.value = !isAchatCollapsed.value
  isPaiementCollapsed.value = !isPaiementCollapsed.value
}

onMounted(() => {
  if (route.params.rechargementId) {
    numeroRechargement.value = route.params.rechargementId
    verifierRechargement()
  }
})

function valideStepOne(e) {
  if (!titreSelectionne.value && !produit.value) {
    e.preventDefault()
    return
  }

  if (isNewTitreSelected.value) {
    achat(e)
  } else {
    rechargement(e)
  }
}

// Rechargement
function rechargement(e) {
  e.preventDefault()
  if (loading.value) {
    return
  }
  loading.value = true

  axios.post('/commandes/prepareRechargement', {
    codeProduit: titreSelectionne.value.codeProduit,
    email: email.value,
    titreARecharger: titreSelectionne.value.titreId,
    dateDebutTitre: dateDebutTitre.value,
    needFacture: needFacture.value,
    justificatifProduitFile: justificatifProduitFile.value,
    reductionId: titreSelectionne.value.reductionId
  })
    .then(
      succes => {
        console.log('succes', succes.data)
        paymentToken.value = succes.data.token
        // On récupère le token et on initialise payline
        loadPayline(succes.data.production).then(() => {
          toggleCollapse()
          loading.value = false
        })
      },
      erreur => {
        loadingTitre.value = false
        console.error('ERREUR', erreur.body)
        const msg = erreur?.response?.data || 'Erreur lors de la préparation de la commande.'
        erreurMessage.value = msg
      }
    )
}

function calculateMinDate(finValiditeeStr) {
  if ( (new Date(finValiditeeStr)) < new Date(today)) {
    return today
  } else {
    // Si la date de fin de validité est supérieure à aujourd'hui, on propose le début de validité au lendemain
    let newDate = new Date(finValiditeeStr);
    newDate.setDate( newDate.getDate() + 1 );
    return `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`

  }
}

function deselectionnerTitre() {
  isNewTitreSelected.value = true
  titreSelectionne.value = ""
}

async function dateValiditee() {
  if (titreSelectionne.value.nouvelleFinValiditee !== null) {
    axios.get('/titres/calculerDateFin', {
      params: {
        dateRechargement: dateDebutTitre.value,
        titreid: titreSelectionne.value.titreId
      }
    })
      .then(succes => {
        titreSelectionne.value.nouvelleFinValiditee = succes.data
      }, erreur => {

        if (erreur.data === undefined) {
          erreurMessage.value = 'Erreur lors de la récuperation des titres.'
        } else {
          if (erreur.data.status === 500) {
            erreurMessage.value = 'Erreur lors de la récuperation des titres.'
          } else {
            console.error('ERREUR', erreur.body)
            erreurMessage.value = erreur.response.data
          }
        }
        titreSelectionne.value.nouvelleFinValiditee = ''
      })
  }
}


// Achat
function achat(e) {
  e.preventDefault()
  if( loading.value === true) {
    return
  }
  loading.value = true;

  axios.post('/commandes/prepareVente', {
    codeProduit: produit.value.codeProduit,
    email: email.value,
    numeroRechargement: numRechargementSelectionne,
    dateDebutTitre: dateDebutTitre.value,
    needFacture: needFacture.value,
    justificatifProduitFile: justificatifProduitFile.value,
    reductionId: produit.value.reductionId
  })
  .then(
    succes => {
      paymentToken.value = succes.data.token
      // On récupère le token et on initialise payline
      loadPayline(succes.data.production).then(() => {
        toggleCollapse()
      })
    },
    erreur => {
      console.error('ERREUR', erreur.body)
      console.error('Erreur lors de l’achat', erreur)
      erreurMessage.value = erreur?.response?.data || 'Erreur lors de la préparation de la commande.'
    }
  )
  .finally( () => {
    loading.value = false
  })
}

function selectionnerTitre() {
  produit.value = null
  isNewTitreSelected.value = false
  if (titreSelectionne.value.finValiditee !== null) {
    dateDebutTitre.value = calculateMinDate(titreSelectionne.value.finValiditee)
  }
}

function detailValiditee(titre) {
  if (typeof titre.nbTrajets === 'number' && titre.nbTrajets > 0) {
    return ' solde : ' + titre.nbTrajets + ' trajet(s)'
  } else if (typeof titre.nbTrajets === 'number' && titre.nbTrajets === 0) {
    return ' solde : épuisé'
  } else if (typeof titre.finValiditee === 'string' && titre.finValiditee.length > 0) {
    return ' expire le : ' + toFrenchDate(titre.finValiditee)
  }
  return ''
}

function detailFutureValiditee(titre) {
  if (typeof titre.nouveauNbTrajets === 'number' && titre.nouveauNbTrajets > 0) {
    return ' Solde après rechargement : ' + titre.nouveauNbTrajets + ' trajet(s)'
  } else if (typeof titre.nouvelleFinValiditee === 'string' && titre.nouvelleFinValiditee.length > 0) {
    return ' Expiration après rechargement : ' + toFrenchDate(titre.nouvelleFinValiditee)
  }
  return ''
}

async function dateValiditeeNewTitre() {
  if (produit.value && produit.value.type.includes('Abonnement')) {
    axios.get('/titres/calculerDateFinNewTitre', {
      params: {
        dateRechargement: dateDebutNewTitre.value,
        codeProduit: produit.value.codeProduit
      }
    }).then(succes => {
      nouvelleDateFinValiditeeNewTitre.value = succes.data
    })
  }
}
function resetSelections() {
  titreSelectionne.value = ""
  produit.value = null
  isNewTitreSelected.value = false
  dateDebutTitre.value = ''
  dateDebutNewTitre.value = today
  nouvelleDateFinValiditeeNewTitre.value = today
  justificatifProduitFile.value = null
  justificatifValidationMessage.value = ""
  paymentToken.value = undefined
  suiteForm.value = false
}

// Commun
function verifierRechargement() {
  resetSelections();

  if(numeroRechargement.value === null || numeroRechargement.value === ''){
    erreurMessage.value = "Un numéro de carte est obligatoire."
    return;
  }

  // On vire les espaces dans la saisie, on est sympa
  numeroRechargement.value = numeroRechargement.value.replace(/\s/g, '');

  // 1 - obtenir le(s) titre(s) correspondant au numéro de rechargement
  erreurMessage.value = null
  loadingTitre.value = true
  suiteForm.value = false
  titres.value = []
  carteVide.value = null;
  // on stock la valeur sinon elle peut être ré-écrasée si l'utilisateur tape dans le champs après la vérif
  numRechargementSelectionne = numeroRechargement.value;

  axios.get('/titres', {
    params: {
      numeroRechargement: numRechargementSelectionne,
      dateRechargement: dateDebutTitre.value == null ? null : dateDebutTitre.value.toLocaleString()
    }
  })
    .then(succes => {

      if (succes.data === "CARTE_NON_CONNUE"){
        carteVide.value = true;
      } else {
        titres.value = succes.data
        carteVide.value = false;
      }
      suiteForm.value = true

      setTimeout(() => {
        titreList.value.scrollIntoView({ behavior: 'smooth' });
      }, 500)

    }, erreur => {
      const message = erreur.response?.data
      rechargementBloque.value = false
      if (erreur.status === 400) {
        //bloque seulement le rechargement
        erreurMessage.value = message
        rechargementBloque.value = true

        // mais on autorise la suite pour l'achat
        titres.value = []
        carteVide.value = true
        suiteForm.value = true
      } else {
        erreurMessage.value =
          erreur.response?.data ?? 'Titre introuvable.'
      }
    })
    .finally( () => {
      loadingTitre.value = false;
    })

  axios.get('produits/produit-rechargement/' + numeroRechargement.value, {
    params: {
      seeReduction : true,
      showReductionLibelle : true
    }
  })
    .then(succes => {
      catalogue.value = succes.data
      catalogue.value.sort((one, two) => (one.libelle > two.libelle ? 1 : -1))
    }, erreur => {
      if (erreur.data === undefined) {
        erreurMessage.value = 'Erreur lors de la récuperation du catalogue.'
      } else {
        if (erreur.data.status === 500) {
          erreurMessage.value = 'Erreur lors de la récuperation du catalogue.'
        } else {
          console.error('ERREUR', erreur.body)
          erreurMessage.value = erreur.response.data
        }
      }
    })
}

function toCurrency(value) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
}

function toFrenchDate(value) {
  if (value == null || value === '') {
    return ''
  }

  return new Intl.DateTimeFormat('fr-FR').format(new Date(value))
}

function onChangeJustificatifProduitFile(event) {
  const file = event.target.files[0];
  if (file && file.type !== 'application/pdf') {
    justificatifValidationMessage.value = "Format incorrect. Veuillez télécharger un PDF";
    event.target.value = null;
  } else {
    justificatifValidationMessage.value = "";
    justificatifProduitFile.value = file;
  }
}
</script>

<template>
  <div
    :class="{ collapse: !isPaiementCollapsed, show: isPaiementCollapsed }"
    role="tablist"
    class="overflow-auto"
  >
    <div id="rechargement" role="tabpanel">
      <form @submit="valideStepOne">
        <div class="achat container">
          <h1>Rechargement de votre titre de transport</h1>
          <h2>Indiquez le numéro présent sur votre carte</h2>
          <div class="form_recharge">
            <div class="carte_recharge card">
              <div class="card-body">
                <div
                  class="num_rechargement text-center row m-2 d-block mx-auto"
                >
                  <img
                    src="@/assets/rechargement-cartes.png"
                    alt="Carte de rechargement"
                  />
                </div>

                <div class="div_icon_input row rc-form">
                  <div class="col-sm-1 d-none d-sm-block">
                    <i class="fas fa-ticket-alt"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <input
                      type="text"
                      v-model="numeroRechargement"
                      placeholder="ex: 12345"
                      class="input_number form-control"
                      required
                    />
                  </div>
                </div>

                <div
                  v-if="!rechargementBloque"
                  class="fs-6 text-center text-danger my-5"
                >
                  {{ erreurMessage }}
                </div>
                <p v-if="rechargementBloque" class="text-warning text-center">
                  {{ erreurMessage }}
                </p>

                <div class="text-center">
                  <button
                    type="button"
                    @click="verifierRechargement"
                    class="btn btn-vert"
                  >
                    <i class="fas fa-check"></i>Vérifier
                  </button>
                </div>

                <br />

                <p v-if="carteVide" style="text-align: center">
                  Remarque : Merci de bien vérifier le numéro de carte que vous
                  venez d'inscrire ci-dessus
                </p>

                <br />

                <div v-if="loadingTitre" class="div_loader_titre">
                  <div class="loaderTitre" label="Spinning"></div>
                </div>

                <p v-if="titres.length > 0 || carteVide !== null">
                  Choisissez le produit que vous désirez recharger / acheter :
                </p>

                <div class="container choix_titre" ref="titre-list">
                  <div class="row gy-1">
                    <div
                      v-bind:key="titre.titreId"
                      v-if="titres.length > 0 && carteVide !== null"
                      v-for="titre in titres"
                      class="col-md-6 col-12 align-items-stretch"
                    >
                      <div class="div_nature h-100">
                        <label
                          :for="titre.titreId"
                          class="text-center w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                        >
                          <input
                            v-on:change="selectionnerTitre"
                            v-model="titreSelectionne"
                            type="radio"
                            name="nature"
                            class="btn nature"
                            :id="titre.titreId"
                            :value="titre"
                            :disabled="
                              rechargementBloque ||
                              paymentToken !== undefined ||
                              titre.currentCommandeRechargementExists
                            "
                            required
                          />
                          <!-- Titre et validité -->
                          {{ titre.libelleProduit }}
                          <i>( {{ detailValiditee(titre) }} )</i>
                          <br />

                          <!-- Date de Rechargement -->
                          <div
                            v-if="
                              titre.titreId === titreSelectionne.titreId &&
                              titre.finValiditee != null
                            "
                            class="row w-100 pb-2"
                          >
                            <div
                              class="date-de-rechargement col-12 col-sm-7 text-center align-self-center"
                            >
                              Date de rechargement
                            </div>
                            <div class="col-sm-5 col-12">
                              <input
                                type="date"
                                class="form-control"
                                v-model="dateDebutTitre"
                                @change="dateValiditee"
                                :min="calculateMinDate(titre.finValiditee)"
                                required
                              />
                            </div>
                          </div>
                          <!-- Coût et expiration -->
                          <span
                            v-if="
                              titre.tarif !== null &&
                              !titre.currentCommandeRechargementExists
                            "
                            >Coût du rechargement :
                            {{ toCurrency(titre.tarif) }}</span
                          >
                          <br />
                          <i
                            v-if="
                              titreSelectionne !== '' &&
                              titreSelectionne === titre &&
                              !titre.currentCommandeRechargementExists &&
                              titreSelectionne.nouvelleFinValiditee === null
                            "
                            >( {{ detailFutureValiditee(titre) }} )</i
                          >
                          <i
                            v-else-if="
                              titreSelectionne !== '' &&
                              titreSelectionne === titre &&
                              !titre.currentCommandeRechargementExists &&
                              titre.nouvelleFinValiditee !== null
                            "
                          >
                            Expiration après rechargement :
                            <u
                              >{{
                                toFrenchDate(
                                  titreSelectionne.nouvelleFinValiditee,
                                )
                              }}
                            </u>
                          </i>
                          <div
                            v-else-if="titre.currentCommandeRechargementExists"
                            class="text-danger font-weight-bold"
                          >
                            Rechargement en cours, vous ne pouvez recharger ce
                            titre pour le moment.
                          </div>
                        </label>
                      </div>
                      <!-- Option pour un nouveau titre -->
                    </div>
                    <div
                      key="newTitre"
                      class="col-md-6 col-12 align-items-stretch"
                    >
                      <div
                        class="div_nature h-100"
                        v-if="titres.length > 0 || carteVide !== null"
                      >
                        <label
                          class="text-center h-100 w-100 d-flex flex-column justify-content-center align-items-center"
                        >
                          <input
                            type="radio"
                            name="nature"
                            class="btn nature h-100 w-100"
                            id="newTitre"
                            :disabled="catalogue.length === 0"
                            v-on:change="deselectionnerTitre"
                            required
                          />
                          <h6>Achat d'un nouveau titre</h6>
                          <br />
                          <div
                            v-if="catalogue.length === 0 || carteVide === null"
                            class="text-danger font-weight-bold"
                          >
                            Il n'est pas possible d'ajouter un titre à cette
                            carte.
                          </div>
                          <div class="row w-100" v-else-if="isNewTitreSelected">
                            <div class="col-12">
                              <select
                                @change="dateValiditeeNewTitre"
                                v-model="produit"
                                class="form-control my-2"
                                required
                              >
                                <option disabled :value="null">
                                  Veuillez sélectionner un produit
                                </option>
                                <option
                                  v-for="item in catalogue"
                                  :key="item.id"
                                  :value="item"
                                >
                                  {{ item.libelle }} ({{
                                    toCurrency(item.tarif)
                                  }})
                                </option>
                              </select>
                            </div>
                          </div>
                          <p v-else>
                            Si vous souhaitez ajouter un titre à votre carte,
                            cliquez ici.
                          </p>
                          <!-- Date de Rechargement pour le nouveau produit -->
                          <div
                            v-if="
                              produit && produit.type.includes('Abonnement')
                            "
                            class="row w-100 pb-2"
                          >
                            <div
                              class="col-12 col-sm-7 text-center align-self-center date-de-rechargement"
                            >
                              Date de rechargement
                            </div>
                            <div class="col-sm-5 col-12">
                              <input
                                type="date"
                                class="form-control"
                                v-model="dateDebutNewTitre"
                                @change="dateValiditeeNewTitre"
                                :min="today"
                                required
                              />
                            </div>
                          </div>
                          <span v-if="produit"
                            >Coût de l'achat : {{ toCurrency(produit.tarif)
                            }}<br
                          /></span>
                          <br />
                          <i
                            v-if="
                              produit && produit.type.includes('Abonnement')
                            "
                          >
                            Expiration après achat :
                            <u>{{
                              toFrenchDate(nouvelleDateFinValiditeeNewTitre)
                            }}</u>
                          </i>
                          <i v-if="produit && produit.type === 'Trajet'">
                            Solde après achat : {{ produit.uniter }} trajet(s)
                          </i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Fin de la grille -->
                <div
                  v-if="
                    (suiteForm && titreSelectionne !== '') ||
                    (isNewTitreSelected && produit)
                  "
                >
                  <p class="info_mail">
                    Afin de pouvoir finaliser votre achat, merci de renseigner
                    votre adresse email :
                  </p>

                  <p>
                    <input v-model="needFacture" type="checkbox" />
                    Je souhaite avoir une facture.
                  </p>

                  <div class="div_icon_input row rc-form">
                    <div class="col-12 col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-envelope"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        v-model="email"
                        type="email"
                        class="form-control"
                        id="exampleFormControlInput1"
                        placeholder="Adresse E-mail"
                        required
                      />
                    </div>
                  </div>

                  <p
                    v-if="
                      (titreSelectionne !== '' &&
                        titreSelectionne.libelleProduit.includes('CSS')) ||
                      (produit !== null && produit.type.includes('CSS'))
                    "
                    class="info_mail"
                  >
                    Merci de fournir un justificatif pour avoir la réduction
                    Complémentaire Santé Solidaire (CSS)
                  </p>

                  <div
                    v-if="
                      (titreSelectionne !== '' &&
                        titreSelectionne.libelleProduit.includes('CSS')) ||
                      (produit !== null && produit.type.includes('CSS'))
                    "
                    class="div_icon_input"
                  >
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-file"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        ref="justificatifProduit"
                        type="file"
                        @change="onChangeJustificatifProduitFile"
                        accept="application/pdf"
                        class="form-control"
                        multiple
                        required
                      />
                      <p
                        :style="{
                          color:
                            justificatifValidationMessage.value ===
                            'Format correct.'
                              ? 'green'
                              : 'red',
                        }"
                      >
                        {{ justificatifValidationMessage }}
                      </p>
                    </div>
                  </div>

                  <div class="text-center">
                    <button
                      :disabled="!email"
                      class="btn btn-vert"
                      type="submit"
                    >
                      <i class="fas fa-arrow-right"></i>
                      Valider
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div
    :class="{ collapse: isPaiementCollapsed, show: !isPaiementCollapsed }"
    role="tabpanel"
  >
    <div class="paiement container">
      <h1>Finalisation de votre achat - Paiement</h1>
      <h2>Récapitulatif de votre achat</h2>

      <div class="carte_recap card">
        <div class="card-body">
          <h5
            style="text-align: center"
            v-if="titreSelectionne !== '' && titreSelectionne.tarif !== null"
            class="card-text"
          >
            Produit : {{ titreSelectionne.libelleProduit }}
            <br />
            Montant : {{ toCurrency(titreSelectionne.tarif) }}
          </h5>
          <h5
            style="text-align: center"
            v-if="produit !== null && produit.tarif !== null"
            class="card-text"
          >
            Produit : {{ produit.libelle }}
            <br />
            Montant : {{ toCurrency(produit.tarif) }}
          </h5>
        </div>
      </div>

      <div
        id="PaylineWidget"
        :data-token="paymentToken"
        data-template="column"
        data-auto-init="true"
        data-embeddedredirectionallowed="false"
        data-event-didshowstate="handleWidgetDidShowState"
        data-event-finalstatehasbeenreached="handleFinalStateReached"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/main';

p {
  font-weight: bold;
}

.md-steppers .md-steppers-navigation {
  display: none;
}

.div_nature {
  display: flex;
  flex-direction: column;
  background-color: #b7b7b7;
  color: white;
  padding: 1em;

  .date-de-rechargement {
    word-wrap: normal !important;
    overflow-wrap: normal;
    word-break: keep-all;
    white-space: normal;
  }

  input[type='radio'] {
    display: none;
  }
  label {
    cursor: pointer;
  }

  &:has(input[type='radio']:checked) {
    background-color: var(--color-bleu);
    box-shadow: 0 0 5px #5d5c5c;
  }

  &:has(input[type='radio']:checked) * {
    background-color: var(--color-bleu);
    color: white;
    cursor: default;
  }

  select {
    color: black !important;
    background: white !important;
  }
  input[type='date'] {
    color: black !important;
    background: white !important;
  }

  &:has(input[type='radio']:disabled) {
    background-color: lightgray !important;
    color: #999;
  }

  &:has(input[type='radio']:disabled) * {
    background-color: lightgray !important;
    color: #999;
  }

  @keyframes borderAnimation {
    0% {
      border-color: gray;
    }
    50% {
      border-color: lightgray;
    }
    100% {
      border-color: gray;
    }
  }
}

.form_recharge {
  .carte_recharge {
    border: none !important;

    .num_rechargement {
      p {
        font-weight: bold;
      }

      img {
        max-width: 100%;
        height: auto;
        width: 45%;
      }
    }

    .info_mail {
      margin-top: 3rem;
    }

    .div_icon_input {
      max-width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
    }

    .div_icon_input:focus-within {
      i {
        color: var(--color-bleu-logo);
      }
    }
  }
}

.paiement {
  h1 {
    text-align: center;
  }

  .carte_recap {
    h6 {
      color: var(--color-bleu-logo);
    }

    h5 {
      text-align: left;
    }
  }
}

.div_loader_titre {
  text-align: center;

  .loaderTitre {
    width: 3rem;
    height: 3rem;
    color: var(--color-bleu-logo);
  }
}

.radio-toolbar {
  width: 100%;

  input[type='radio'] {
    opacity: 0;
    position: inherit;
    width: 0;
  }

  label {
    display: flex;
    background-color: white;
    padding: 10px 20px;
    font-family: sans-serif, Arial;
    font-size: 16px;
    border: 1px solid #ced4da;
    border-radius: 4px;

    p {
      margin: auto;
    }
  }

  input[type='radio']:checked + label {
    background-color: var(--color-bleu-logo);
    color: white;
  }

  input[type='radio']:focus + label {
    border: 2px dashed #444;
  }
}

.div_nature {
  display: flex;

  label {
    margin: auto;
    text-align: center;
  }

  .nature {
    border-color: #ced4da;
    color: var(--color-vert-logo);
  }

  span {
    margin: auto;
  }
}
</style>
